import { formatCurrency } from "@/utils/format-currency";
import { format, parseISO, isValid } from "date-fns";
import { DisputeStatusChip } from "./dispute-status-chip";
import { ChargebackActionsPopover } from "./chargeback-actions-popover";
import { CHARGEBACK_STATUS } from "../../data";

const formatDate = (date) => {
  if (!date) return "N/A";
  const parsed = parseISO(date);
  return isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A";
};

export const ChargebackColumns = [
  {
    accessorKey: "merchantCustomerDisputeId",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Dispute ID</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.merchantCustomerDisputeId}</div>
    ),
  },
  {
    accessorKey: "customerName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Customer</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.customerName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "merchantName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Merchant</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.merchantName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "transactionAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Transaction</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {formatCurrency(row.original.transactionAmount)} on{" "}
        {formatDate(row.original.transactionDate)}
      </div>
    ),
  },
  {
    accessorKey: "disputeResolutionStatus",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <DisputeStatusChip
        status={row.original.disputeResolutionStatus}
        config={CHARGEBACK_STATUS}
      />
    ),
  },
  {
    accessorKey: "merchantResponseDueDate",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Due Date</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.merchantResponseDueDate)}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actions</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", cursor: "pointer" }}>
        <ChargebackActionsPopover chargeback={row.original} />
      </div>
    ),
  },
];
